import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { BUILD_INFO } from './environments/build-info';

// Lets support read the running build from the console.
console.info('[build]', BUILD_INFO.assetVersion, BUILD_INFO.builtAt);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
